<template>
    <f7-page class="page-report-date has-footer">
        <f7-navbar :sliding="false">
            <f7-nav-left back-link="Trở lại"></f7-nav-left>
            <f7-nav-title sliding>HOA HỒNG</f7-nav-title>
        </f7-navbar>
        <f7-block inset class="mt-0 mb-2">
            <f7-segmented raised>
                <f7-button :active="tab_active === 'today'" @click.prevent="tab_active = 'today', getReportToday()">
                    HÔM NAY
                </f7-button>
                <f7-button :active="tab_active === 'this_week'" @click.prevent="tab_active = 'this_week', getReportThisWeek()">
                    TUẦN NÀY
                </f7-button>
                <f7-button :active="tab_active === 'last_week'" @click.prevent="tab_active = 'last_week', getReportLastWeek()">
                    TUẦN TRƯỚC
                </f7-button>
                <f7-button style="width: 120px" :active="tab_active === 'custom'" @click.prevent="tab_active = 'custom'">
                    <f7-icon f7="calendar"></f7-icon>
                </f7-button>
            </f7-segmented>
        </f7-block>
        <f7-list inline-labels v-if="tab_active === 'today' || tab_active === 'custom'" class="mt-0">
            <f7-list-input
                :label="tab_active === 'today' ? 'Ngày' : 'Từ ngày'"
                type="datepicker"
                :placeholder="tab_active === 'today' ? 'Chọn ngày' : 'Từ ngày'"
                :value="[this.report_date]"
                @calendar:change="function(values){report_date = values[0], refreshChilds()}"
                :calendar-params="{dateFormat: 'dd/mm/yyyy', locale: 'vi-VN', closeOnSelect: true, openIn: 'customModal'}">
                <f7-icon slot="media" ios="f7:calendar"></f7-icon>
            </f7-list-input>
            <f7-list-input
                label="Đến ngày"
                type="datepicker"
                v-if="tab_active === 'custom'"
                placeholder="Đến ngày"
                :value="[this.report_date_to]"
                @calendar:change="function(values){report_date_to = values[0], refreshChilds()}"
                :calendar-params="{dateFormat: 'dd/mm/yyyy', locale: 'vi-VN', closeOnSelect: true, openIn: 'customModal'}">
                <f7-icon slot="media" ios="f7:calendar"></f7-icon>
            </f7-list-input>
        </f7-list>
        <f7-block strong class="mt-0">
            <f7-chip v-for="(item, idx) in breadcrumbs" :key="idx"
                     :text="idx === 0 ? (selected_type === 0 ? item.username : (selected_type === 1 ? item.username + ' (Mã giới thiệu)' : item.username + ' (Truyền thống)')) : item.username" @click.prevent="clickChip(item, idx)" class="mr-05">
                <img slot="media" :src="require('@/assets/images/no-avatar.png')"/>
            </f7-chip>
        </f7-block>
        <f7-row v-if="breadcrumbs.length > 0" class="mb-1">
            <f7-col>
                <div>Tổng USDT sử dụng: <strong> {{ totalSpentUsdt }} USDT</strong></div>
                <div>Tổng Hoa hồng: <strong>{{ totalCommissionUsdt }} USDT</strong></div>
            </f7-col>
        </f7-row>
        <f7-list media-list class="search-list mt-0" v-if="selected_type === 0">
            <f7-list-item title="Mã giới thiệu" @click.prevent="selected_type = 1">
                <div slot="after-title" class="item-after">
                    <span class="text-xs">
                        Sử dụng: <strong>{{ totalSpentUsdtMGT }}</strong> USDT<br/>
                        Hoa hồng: <strong>{{ totalCommissionUsdtMGT }}</strong> USDT
                    </span>
                </div>
            </f7-list-item>
            <f7-list-item title="Truyền thống" @click.prevent="selected_type = 4">
                <div slot="after-title" class="item-after">
                    <span class="text-xs">
                        Sử dụng: <strong>{{ totalSpentUsdtTT }}</strong> USDT<br/>
                        Hoa hồng: <strong>{{ totalCommissionUsdtTT }}</strong> USDT
                    </span>
                </div>
            </f7-list-item>
        </f7-list>
        <f7-list media-list class="search-list mt-0" v-else>
            <f7-list-input
                type="text"
                outline
                floating-label
                label="Tìm kiếm"
                placeholder="Tìm kiếm"
                :value="search"
                @input="search = $event.target.value"
            >
            </f7-list-input>
            <f7-list-item v-for="(item, idx) in filtered_childs" :key="idx" :title="item.username" @click.prevent="getChilds(item.username), search = ''">
                <small slot="subtitle" v-if="item.latest_tnx">
                    {{ item.latest_tnx.created_at | moment('DD/MM/YYYY hh:mm') }}
                </small>
                <div slot="after-title" class="item-after">
                    <span class="text-xs">
                        Sử dụng: <strong>{{ item.spent_usdt ? item.spent_usdt : 0 }}</strong> USDT<br/>
                        Hoa hồng: <strong>{{ item.commission_usdt ? item.commission_usdt : 0 }}</strong> USDT
                    </span>
                </div>
            </f7-list-item>
        </f7-list>
        <f7-block v-if="!is_loading && selected_type !== 0 && filtered_childs.length === 0" strong>
            Không có tài khoản nào gia hạn
        </f7-block>
    </f7-page>
</template>
<style scoped>
.text-xs{
    font-size: 10pt;
}
.item-subtitle{
    margin-top: -10px;
}
</style>
<script>
import moment from "moment-timezone";
import { mapState } from 'vuex';

export default {
    data() {
        return {
            today: new Date(),
            report_date: new Date(),
            report_date_to: new Date(),
            report_date_string: '',
            breadcrumbs: [],
            current_childs: [],
            item_selected: {},
            search: '',
            is_loading: true,
            selected_type: 0,
            tab_active: 'today'
        }
    },
    computed: {
        ...mapState(['user_info']),
        filtered_childs() {
            let self = this;
            return self._.orderBy(self._.filter(self.current_childs, function(o) {
                return (self.selected_type === 0 || o.account_type === self.selected_type) && o.commission_usdt > 0 && ((self.search === '') || (o.username.toLowerCase().indexOf(self.search.toLowerCase()) >= 0))
            }), ['username'], ['asc']);
        },
        totalSpentUsdt(){
            return this._.reduce(this.filtered_childs, function(sum, o){
                return sum + o.spent_usdt;
            }, 0);
        },
        totalCommissionUsdt() {
            return this._.reduce(this.filtered_childs, function(sum, o) {
                return sum + o.commission_usdt;
            }, 0);
        },
        mgtChilds(){
            let self = this;
            return self._.orderBy(self._.filter(self.current_childs, function(o) {
                return (o.account_type === 1) && o.commission_usdt > 0 && ((self.search === '') || (o.username.toLowerCase().indexOf(self.search.toLowerCase()) >= 0))
            }), ['username'], ['asc']);
        },
        ttChilds() {
            let self = this;
            return self._.orderBy(self._.filter(self.current_childs, function(o) {
                return (o.account_type === 4) && o.commission_usdt > 0 && ((self.search === '') || (o.username.toLowerCase().indexOf(self.search.toLowerCase()) >= 0))
            }), ['username'], ['asc']);
        },
        totalSpentUsdtMGT() {
            return this._.reduce(this.mgtChilds, function(sum, o) {
                return sum + o.spent_usdt;
            }, 0);
        },
        totalCommissionUsdtMGT() {
            return this._.reduce(this.mgtChilds, function(sum, o) {
                return sum + o.commission_usdt;
            }, 0);
        },
        totalSpentUsdtTT() {
            return this._.reduce(this.ttChilds, function(sum, o) {
                return sum + o.spent_usdt;
            }, 0);
        },
        totalCommissionUsdtTT() {
            return this._.reduce(this.ttChilds, function(sum, o) {
                return sum + o.commission_usdt;
            }, 0);
        }
    },
    methods: {
        getChilds(username, breadcrumbs_push = 1) {
            const self = this;

            if (moment(this.report_date).format('YYYY-MM-DD') === moment(this.report_date_to).format('YYYY-MM-DD')) {
                self.report_date_string = moment(this.report_date).format('DD/MM/YYYY');
            }
            else{
                self.report_date_string = moment(this.report_date).format('DD/MM/YYYY') + ' đến ' + moment(this.report_date_to).format('DD/MM/YYYY');
            }

            self.current_childs = [];
            self.is_loading = true;

            self.$f7.preloader.show();

            self.$store.dispatch('getAgentHistories', {
                    username: username,
                    from_date: moment(this.report_date).format('YYYY-MM-DD 00:00:00'),
                    to_date: moment(this.report_date_to).format('YYYY-MM-DD 23:59:59')
                })
                .then((data) => {
                    if (breadcrumbs_push === 1) {
                        self.breadcrumbs.push({
                            username: username
                        });
                    }

                    this.$f7.preloader.hide();
                    this.is_loading = false;
                    this.current_childs = data;
                })
                .catch((error) => {
                    this.$f7.preloader.hide();
                    this.is_loading = false;
                    this.$f7.dialog.alert(error, 'LỖI');
                });
        },
        refreshChilds() {
            if (this.breadcrumbs.length){
                this.getChilds(this.breadcrumbs[this.breadcrumbs.length - 1].username, 0);
            }
        },
        clickChip(item, idx) {
            if (idx === 0){
                this.selected_type = 0;
            }
            this.breadcrumbs.length = idx;
            this.search = '';
            this.getChilds(item.username);
        },
        getReportToday() {
            this.report_date = moment().tz('Asia/Ho_Chi_Minh').format('YYYY-MM-DD');
            this.report_date_to = moment().tz('Asia/Ho_Chi_Minh').format('YYYY-MM-DD');

            this.refreshChilds();
        },
        getReportThisWeek() {
            this.report_date = moment().tz('Asia/Ho_Chi_Minh').startOf('isoWeek').format('YYYY-MM-DD');
            this.report_date_to = moment().tz('Asia/Ho_Chi_Minh').endOf('isoWeek').format('YYYY-MM-DD');

            this.refreshChilds();
        },
        getReportLastWeek() {
            this.report_date = moment().tz('Asia/Ho_Chi_Minh').subtract(1, 'week').startOf('isoWeek').format('YYYY-MM-DD');
            this.report_date_to = moment().tz('Asia/Ho_Chi_Minh').subtract(1, 'week').endOf('isoWeek').format('YYYY-MM-DD');

            this.refreshChilds();
        }
    },
    // watch: {
    //     report_date() {
    //         this.refreshChilds(this.report_date, this.report_date_to);
    //     },
    //     report_date_to() {
    //         this.refreshChilds(this.report_date, this.report_date_to);
    //     }
    // },
    mounted(){
        this.breadcrumbs.push({
            username: this.user_info.username
        });

        this.refreshChilds();
    }
};
</script>
